// extracted by mini-css-extract-plugin
module.exports = {"root":"Ticket_root__2-5PZ","checkbox":"Ticket_checkbox__pXN2w","address":"Ticket_address__3aXy8","index":"Ticket_index__1pIfs","delivery_time":"Ticket_delivery_time__2hrbY"};